import { render } from "./Notification.vue?vue&type=template&id=a00db45c"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Advanced/Notification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a00db45c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a00db45c', __exports__)) {
    api.reload('a00db45c', __exports__)
  }
  
  module.hot.accept("./Notification.vue?vue&type=template&id=a00db45c", () => {
    api.rerender('a00db45c', render)
  })

}


export default __exports__